import styled from 'styled-components'
import { Button as CosmaButton } from 'is24-corecss'

type CosmaButtonProps = {
  primary?: string
  secondary?: string
  secondaryLight?: string
  textColor?: string
  appearance?: 'primary' | 'secondary' | 'tertiary' | 'ghost' | 'inverted'
  iconStandalone?: boolean
  textStyle?: boolean
  size?: 'small' | 'medium' | 'large'
  renderContainer?: (props: JSX.Element) => JSX.Element
  iv24BackgroundColor?: string
} & JSX.IntrinsicElements['button']

const Button = styled(CosmaButton)`
  #rle-wizard & {
    ${(props: CosmaButtonProps) =>
      props.primary &&
      `
    &:enabled{
      background-color: ${props.primary} !important;
      border-color: ${props.primary} !important;
    }

    &:hover{
    opacity:0.5;
    color: ${props.textColor}!important;
    }
  `}

    ${(props: CosmaButtonProps) =>
      props.secondaryLight &&
      `
    &:disabled{
       background-color: ${props.secondaryLight}!important;
       border-color: ${props.secondaryLight}!important;
       color: ${props.textColor}!important;
       opacity:0.5;
      }
  `}

  ${(props: CosmaButtonProps) =>
      props.textColor &&
      `
     color: ${props.textColor};
  `}

  ${(props: CosmaButtonProps) =>
      props.iv24BackgroundColor &&
      `
    &:enabled{
      background-color: ${props.secondary};
      border-color: ${props.secondary};
    }

    &:hover{
    opacity:0.5;
    color: ${props.textColor}!important;
    }
  `}
  }
`

export { Button }
